import {
  List,
  Datagrid,
  FunctionField,
  TextInput,
  BooleanInput,
  RaRecord,
} from 'react-admin';
import { PersonInlineCell, Vehicle, WorkSystemCell, WorkPermitCell, AvailableFromCell } from './cells';
import { ChipCell, compactDatagridSx } from '../../shared/listCells';
import { Stack } from '@mui/material';
import { SyncStatus } from '../SyncStatus';
import { menuLabel } from '../menuConfig';

const filters = [
  <TextInput source="q" label="Nazwisko, mail, karta" alwaysOn />,
  <BooleanInput source="zPojazdem" label="Tylko z pojazdem" alwaysOn />,
  // `defaultValue`: filtr dodany z „Dodaj filtr” od razu działa (e2e, 28.09.2026).
  <BooleanInput source="active" label="Tylko aktywni" defaultValue />,
  // Poprawa brzmienia 01.10.2026: filtr dotyczy zezwolenia na pracę
  // (wcześniej „Termin pracy minął”). Klucz `terminMinal` bez zmian.
  <BooleanInput source="terminMinal" label="Zezwolenie po terminie" defaultValue />,
];

/**
 * Kartoteka kierowców — lista.
 *
 * Źródłem jest TMS klienta; u nas wyłącznie do odczytu. Dane osobowe
 * i uprawnienia prowadzi kadra po ich stronie.
 */
export const DriverList = () => (
  <List
    filters={filters}
    sort={{ field: 'surname', order: 'ASC' }}
    perPage={25}
    title={menuLabel('drivers')}
  >
    <Stack spacing={1}>
      {/* Kartoteka pochodzi z TMS (W12): kiedy ostatnio pobrana i z jakim wynikiem. */}
      <SyncStatus />
    <Datagrid rowClick="show" bulkActionButtons={false} sx={compactDatagridSx}>
      <FunctionField label="Kierowca" render={(r: RaRecord) => <PersonInlineCell record={r} />} />
      <FunctionField label="Pojazd" render={(r: RaRecord) => <Vehicle record={r} />} />
      <FunctionField label="System pracy" render={(r: RaRecord) => <WorkSystemCell record={r} />} />
      <FunctionField
        label="Zezwolenie do"
        render={(r: RaRecord) => (
          <ChipCell max={220}>
            <WorkPermitCell record={r} />
          </ChipCell>
        )}
      />
      {/* Szacunek z limitów czasu jazdy („ok.”) albo nieobecność z kartoteki
          TMS (fakt) — patrz `cells.tsx`. Nagłówek bez „(szacunek)” od
          07.10.2026, bo nieobecność szacunkiem nie jest. Znacznik skrócony
          na liście; pełny opis i założenia są w podpowiedzi. */}
      <FunctionField
        label="Dostępność"
        render={(r: RaRecord) => (
          <ChipCell max={300}>
            <AvailableFromCell record={r} />
          </ChipCell>
        )}
      />
    </Datagrid>
    </Stack>
  </List>
);
